import { MerchantEmailTrigger } from "@redotech/redo-model/merchant-email-trigger";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const sendTestMerchantEmail = {
  name: "sendTestMerchantEmail" as const,
  input: z.object({
    trigger: createEnum(MerchantEmailTrigger),
    htmlTemplate: z.string(),
    subject: z.string(),
    recipientEmail: z.email(),
    variables: z.record(z.string(), z.string()),
  }),
  output: z.object({ success: z.boolean() }),
};
